import _ from 'lodash'

export default {
  baseOnPrice(state) {
    return state.baseOnPrice
  },
  planDetail(state) {
    return state.planDetail
  },
  customerPlan(state) {
    return _.cloneDeep(state.customerPlan)
  },
  isUseCoupon(state) {
    return state.isUseCoupon
  },
  isUseBenepoPoint(state) {
    return state.isUseBenepoPoint
  },
  getOrder(state) {
    return _.cloneDeep(state.order)
  },
  pointRemain(state) {
    return state.pointRemain
  }
}